const isServer = typeof window === 'undefined';

export const currentEnvironment = isServer ?
  process.env.NODE_ENV :
  window.ENV;

export const isProduction = currentEnvironment === 'production';



// WEBPACK FOOTER //
// ./spa/lib/environment.jsx